import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"ma-0 pa-0"},_vm._l((_vm.values),function(v){return _c('img',{key:v.id,staticClass:"ma-0 pa-0",attrs:{"width":"32px;","height":"32px;","src":v.path}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }